/**
 * Ürün açıklamalarını ve SEO özelliklerini zenginleştiren yardımcı fonksiyonlar
 * Bu modül, ürün verilerini SEO dostu formatlara dönüştürmek için kullanılır
 */

/**
 * Ürün açıklamasını zenginleştirir
 * @param {Object} product - Ürün nesnesi
 * @returns {String} Zenginleştirilmiş açıklama
 */
export const enrichProductDescription = (product) => {
  if (product.description && product.description.length > 100) {
    return product.description;
  }
  
  // Temel açıklama
  let description = `${product.name} - Özel tasarım telefon kılıfı. `;
  
  // Ürün tipine göre açıklama ekle
  if (product.type === 'custom-products') {
    description += 'Kişiselleştirilmiş özel tasarım. ';
  }
  
  // Ürün kategorisine göre açıklama ekle
  if (product.collections && product.collections.name) {
    const category = product.collections.name.toLowerCase();
    
    switch (true) {
      case category.includes('müşteri tasarımları'):
      case category.includes('musteri tasarimlari'):
        description += 'Müşterilerimizin kendi tasarladığı özel telefon kılıfı. Tamamen kişiye özel üretilen bu kılıflar, sizin hayal gücünüzün bir yansıması. İster kendi fotoğrafınız, ister sevdiklerinizin resimleri veya kendi çizimleriniz - hayalinizdeki her tasarımı telefonunuza taşıyabilirsiniz. Yüksek kaliteli baskı teknolojisi ile renklerin canlılığı uzun süre korunur. ';
        break;
      case category.includes('film'):
        description += 'Film ve sinema dünyasından ilham alan özel tasarım telefon kılıfı. Klasik filmlerden, popüler dizilere ve çizgi film karakterlerine kadar sinema tutkunları için hazırlanmış koleksiyon. Favori film karakterlerinizi, unutulmaz film sahnelerini ve ikonik film afişlerini telefonunuzda taşıyın. Sinema tutkunları için ideal bir seçim. ';
        break;
      case category.includes('köpekler'):
      case category.includes('kopek'):
        description += 'Köpek severler için özel tasarlanmış telefon kılıfı. Sevimli yavru köpeklerden, sadık dostlarımıza kadar çeşitli köpek ırklarını içeren tasarımlar. Labrador, Golden Retriever, Husky, Pug ve daha birçok köpek ırkının yer aldığı bu koleksiyon, köpek dostlarımızın sevimli dünyasını telefonunuza taşıyor. Köpek sahipleri ve hayvan severler için mükemmel bir hediye. ';
        break;
      case category.includes('kediler'):
      case category.includes('kedi'):
        description += 'Kedi severler için özel tasarlanmış telefon kılıfı. Sevimli yavru kedilerden, asil ev kedilerine kadar çeşitli kedi türlerini içeren tasarımlar. Tekir, British Shorthair, Siyam, Maine Coon ve daha birçok kedi türünün yer aldığı bu koleksiyon, kedi dostlarımızın gizemli ve sevimli dünyasını telefonunuza taşıyor. Kedi sahipleri ve hayvan severler için ideal bir seçim. ';
        break;
      case category.includes('burçlar'):
      case category.includes('burc'):
        description += 'Astroloji ve burç temalı özel tasarım telefon kılıfı. 12 burç sembolünü ve özelliklerini yansıtan sanatsal tasarımlar. Koç, Boğa, İkizler, Yengeç, Aslan, Başak, Terazi, Akrep, Yay, Oğlak, Kova ve Balık burçlarının karakteristik özelliklerini ve sembollerini içeren bu koleksiyon, astroloji meraklıları için özel olarak hazırlandı. Burcunuzun enerjisini ve özelliklerini telefonunuzda taşıyın. ';
        break;
      case category.includes('hayvanlar'):
      case category.includes('hayvan'):
        description += 'Çeşitli hayvan türlerini içeren özel tasarım telefon kılıfı. Vahşi doğadan evcil hayvanlara, deniz canlılarından orman sakinlerine kadar geniş bir yelpazede hayvan dostlarımızı içeren tasarımlar. Detaylı ve canlı hayvan görselleri ile telefonunuza karakter katın. Doğa ve hayvan severlerin vazgeçilmezi olacak bu koleksiyon, hayvanların güzelliğini ve çeşitliliğini yansıtıyor. ';
        break;
      case category.includes('nordik-iskandinav tanrılar'):
      case category.includes('nordik'):
      case category.includes('iskandinav'):
        description += 'Nordik ve İskandinav mitolojisinden ilham alan özel tasarım telefon kılıfı. Odin, Thor, Loki, Freya gibi İskandinav tanrılarını ve mitolojik hikayelerini modern bir yorumla sunan tasarımlar. Viking kültürü ve İskandinav sembollerini içeren bu koleksiyon, mitoloji meraklıları ve fantastik dünya severleri için ideal. Kuzeyin güçlü tanrılarının hikayelerini telefonunuzda taşıyın. ';
        break;
      case category.includes('mısır tanrıları'):
      case category.includes('misir tanrilari'):
      case category.includes('mısır'):
        description += 'Antik Mısır mitolojisinden ilham alan özel tasarım telefon kılıfı. Ra, Anubis, Osiris, Isis gibi Mısır tanrılarını ve mitolojik hikayelerini modern bir yorumla sunan tasarımlar. Hiyeroglifler, piramitler ve Mısır sembollerini içeren bu koleksiyon, antik uygarlıklar ve mitoloji meraklıları için özel olarak hazırlandı. Nilin gizemli tanrılarının hikayelerini telefonunuzda taşıyın. ';
        break;
      case category.includes('yunan tanrıları'):
      case category.includes('yunan tanrilari'):
      case category.includes('yunan'):
        description += 'Antik Yunan mitolojisinden ilham alan özel tasarım telefon kılıfı. Zeus, Poseidon, Athena, Apollo gibi Yunan tanrılarını ve mitolojik hikayelerini modern bir yorumla sunan tasarımlar. Olimpos Dağının güçlü tanrılarını ve Yunan mitolojisinin efsanevi kahramanlarını içeren bu koleksiyon, klasik mitoloji meraklıları için ideal. Antik Yunanın büyüleyici hikayelerini telefonunuzda yaşatın. ';
        break;
      case category.includes('türk mitolojisi'):
      case category.includes('turk mitolojisi'):
      case category.includes('türk'):
        description += 'Türk mitolojisinden ilham alan özel tasarım telefon kılıfı. Gök Tanrı, Umay, Erlik, Ülgen gibi Türk mitolojisinin önemli figürlerini ve mitolojik hikayelerini modern bir yorumla sunan tasarımlar. Bozkurt, Ergenekon, Türk damgaları ve diğer kültürel sembolleri içeren bu koleksiyon, Türk kültürü ve mitolojisi meraklıları için özel olarak hazırlandı. Atalarımızın zengin mitolojik mirasını telefonunuzda taşıyın. ';
        break;
      case category.includes('uzak doğu'):
      case category.includes('uzakdoğu'):
        description += 'Uzak Dogu kültüründen ilham alan özel tasarım telefon kılıfı. Japon, Çin ve Kore sanatının inceliklerini, geleneksel motiflerini ve sembollerini içeren tasarımlar. Kiraz çiçekleri, ejderhalar, samuraylar, pagodalar ve daha birçok Uzak Dogu sembolünü içeren bu koleksiyon, Asya kültürüne ilgi duyanlar için hazırlandı. Uzak Dogunun mistik ve zarif dünyasını telefonunuza taşıyın. ';
        break;
      case category.includes('mr. brown özel'):
      case category.includes('mr brown özel'):
      case category.includes('mr. brown'):
        description += 'Mr. Brown Casein özel koleksiyonundan seçkin tasarım telefon kılıfı. Tasarım ekibimizin özenle hazırladığı, trend ve zamansız tasarımları bir araya getiren özel seri. Sınırlı sayıda üretilen bu koleksiyon parçaları, benzersiz ve dikkat çekici tasarımlarıyla öne çıkıyor. Mr. Brown Case kalitesi ve özgünlüğünü yansıtan bu kılıflar, tarzınıza şık bir dokunuş katacak. ';
        break;
      case category.includes('anime'):
        description += 'Anime temalı benzersiz tasarım, anime severlerin koleksiyonuna eklemek isteyeceği özel bir parça. Yüksek kaliteli baskı ile anime karakterlerinin detayları canlı ve net. Japon anime kültürünü yansıtan bu kılıf, otaku ve anime hayranları için mükemmel bir seçim. ';
        break;
      case category.includes('hayvan'):
        description += 'Sevimli hayvan figürlü tasarım, hayvan severlerin telefonlarını şık ve eğlenceli bir şekilde korur. Detaylı ve canlı hayvan görselleri ile telefonunuza karakter katın. Kedi, köpek, kuş ve diğer sevimli hayvan dostlarımızın yer aldığı bu tasarımlar, hayvan severlerin vazgeçilmezi olacak. ';
        break;
      case category.includes('doğa'):
        description += 'Doğa manzaralı etkileyici tasarım, doğa tutkunları için huzur veren bir görsel şölen sunar. Dağlar, ormanlar, göller ve muhteşem gün batımı manzaraları ile doğanın güzelliğini telefonunuza taşıyın. Doğa temalı bu kılıflar, günlük hayatın stresinden uzaklaşmanıza yardımcı olacak. ';
        break;
      case category.includes('mitoloji'):
        description += 'Mitolojik karakterli özel tasarım, mitoloji meraklıları için eşsiz bir koleksiyon parçası. Türk, Yunan, İskandinav ve Mısır mitolojilerinden ilham alan bu tasarımlar, efsanevi tanrılar ve kahramanları modern bir yorumla sunuyor. Mitolojik hikayelerin gücünü ve gizemini telefonunuzda taşıyın. ';
        break;
      case category.includes('sanat'):
        description += 'Sanatsal çizgiler taşıyan özel tasarım, sanat tutkunları için telefonlarını bir sanat eserine dönüştürür. Klasik ve modern sanat akımlarından esinlenen bu kılıflar, ünlü tablolardan ve sanat eserlerinden ilham alır. Telefonunuzu taşınabilir bir sanat galerisine dönüştüren bu tasarımlar, sanat severlerin beğenisini kazanacak. ';
        break;
      case category.includes('manzara'):
        description += 'Etkileyici manzara temalı tasarım, doğanın güzelliklerini telefonunuza taşır. Dağlar, denizler, göller ve şelaleler gibi doğal güzellikleri içeren bu kılıflar, her baktığınızda sizi farklı bir yere götürecek. Yüksek çözünürlüklü manzara fotoğrafları ile telefonunuza estetik bir dokunuş katın. ';
        break;
      case category.includes('fantastik'):
        description += 'Fantastik dünyalardan ilham alan tasarım, hayal gücünüzü zorlayan görsellerle telefonunuzu süsler. Ejderhalar, büyücüler, elfler ve daha birçok fantastik karakter ile dolu bu kılıflar, fantastik edebiyat ve film severlerin favorisi olacak. Gerçeküstü dünyaların kapılarını aralayan bu tasarımlar ile telefonunuz dikkat çekecek. ';
        break;
      case category.includes('uzay'):
        description += 'Uzay ve astronomi temalı bu tasarım, galaksiler, gezegenler ve kozmik manzaralarla telefonunuzu yıldızlara taşır. Derin uzayın gizemli güzelliğini yansıtan bu kılıflar, astronomi meraklıları ve bilim kurgu severler için ideal. Evrenin sonsuzluğunu ve ihtişamını her an yanınızda taşıyın. ';
        break;
      case category.includes('retro'):
        description += 'Retro ve vintage stilini yansıtan bu tasarım, nostaljik bir hava katarak telefonunuzu zamanda yolculuğa çıkarır. 80\'ler ve 90\'ların ikonik desenleri, renkleri ve sembollerini içeren bu kılıflar, geçmişe özlem duyanlar için mükemmel bir seçim. Klasik ve zamansız bir tarz arayanlar için ideal. ';
        break;
      case category.includes('minimalist'):
        description += 'Minimalist ve sade çizgilere sahip bu tasarım, şıklığı ve zarafeti ön plana çıkarır. Basit geometrik şekiller, ince çizgiler ve nötr renklerle oluşturulan bu kılıflar, modern ve yalın bir görünüm arayanlar için biçilmiş kaftan. Az çoktur felsefesini benimseyen kullanıcılar için ideal bir tercih. ';
        break;
      case category.includes('spor'):
        description += 'Spor temalı bu tasarım, favori takımınızı veya spor dalınızı yansıtan görseller ile telefonunuzu kişiselleştirir. Futbol, basketbol, tenis ve daha birçok spor dalına özel tasarımlar ile spor tutkunları için üretilmiştir. Takım renklerinizi ve sembollerinizi gururla taşıyın. ';
        break;
      case category.includes('müzik'):
        description += 'Müzik temalı bu tasarım, müzik tutkunları için notalar, enstrümanlar ve ikonik müzisyenlerden ilham alan görseller sunar. Klasik müzikten rock\'a, caz\'dan elektronik müziğe kadar geniş bir yelpazede müzik zevkinizi yansıtın. Müziğin ritmi ve enerjisi telefonunuzda hayat bulsun. ';
        break;
      case category.includes('soyut'):
        description += 'Soyut ve modern sanat akımlarından esinlenen bu tasarım, alışılmışın dışında bir görsellik sunar. Geometrik şekiller, canlı renkler ve sıra dışı desenler ile oluşturulan bu kılıflar, sanatsal bir ifade arayanlar için ideal. Modern sanatın cesur çizgilerini telefonunuzda taşıyın. ';
        break;
      case category.includes('özel'):
      case category.includes('kişisel'):
        description += 'Tamamen kişiselleştirilmiş özel tasarım, sizin seçtiğiniz fotoğraf veya görselle üretilir. Sevdiklerinizin fotoğrafları, özel anılarınız veya kendi çizimlerinizle oluşturulan bu kılıflar, benzersiz ve size özel. Hayal ettiğiniz her tasarımı telefonunuza taşıyabilirsiniz. ';
        break;
      case category.includes('komik'):
      case category.includes('mizah'):
        description += 'Eğlenceli ve komik tasarımlar içeren bu kılıf, her baktığınızda yüzünüzü güldürecek. Mizahi çizimler, esprili sözler ve neşeli karakterler ile dolu bu tasarımlar, hayata pozitif bakan kullanıcılar için ideal. Telefonunuza eğlenceli bir dokunuş katın. ';
        break;
      case category.includes('gotik'):
      case category.includes('karanlık'):
        description += 'Gotik ve karanlık temalar içeren bu tasarım, gizemli ve etkileyici bir görünüm sunar. Siyah tonları, mistik semboller ve gotik sanat öğeleri ile oluşturulan bu kılıflar, alternatif stil sahipleri için mükemmel bir seçim. Karanlığın çekiciliğini telefonunuzda hissedin. ';
        break;
      case category.includes('deniz'):
      case category.includes('okyanus'):
        description += 'Deniz ve okyanus temalı bu tasarım, maviliklerin huzur veren dünyasını telefonunuza taşır. Mercanlar, deniz canlıları, dalgalar ve kumsallar ile süslenen bu kılıflar, deniz severlerin ve yaz tutkunlarının favorisi olacak. Okyanusun derinliklerini ve kıyıların güzelliğini yanınızda taşıyın. ';
        break;
      default:
        description += 'Benzersiz tasarımlı, kişisel stilinizi yansıtan özel bir telefon kılıfı. Yüksek kaliteli baskı teknolojisi ile üretilen bu kılıf, uzun ömürlü kullanım için tasarlandı. Telefonunuzu korurken tarzınızı da ön plana çıkarın. ';
    }
  }
  
  // Ürün özelliklerine göre açıklama ekle
  if (product.features) {
    if (product.features.includes('waterproof') || product.features.includes('su geçirmez')) {
      description += 'Su geçirmez özelliği ile günlük kullanımda ekstra koruma sağlar. ';
    }
    
    if (product.features.includes('shockproof') || product.features.includes('darbe emici')) {
      description += 'Darbe emici teknolojisi ile düşmelere karşı maksimum koruma sunar. ';
    }
  }
  
  // Genel özellikler
  description += 'Yüksek kaliteli malzemeden üretilmiş olup telefonunuzu darbelere karşı korur. ';
  description += 'Kolay takılıp çıkarılabilir yapısı ile kullanım kolaylığı sağlar. ';
  description += 'Hassas kesim teknolojisi sayesinde tüm düğme ve portlara tam erişim imkanı verir.';
  
  return description;
};

/**
 * Ürün başlığını SEO için optimize eder
 * @param {Object} product - Ürün nesnesi
 * @returns {String} Optimize edilmiş başlık
 */
export const optimizeProductTitle = (product) => {
  if (!product) return '';
  
  let title = product.name;
  
  // Koleksiyon bilgisi ekle
  if (product.collections && product.collections.name) {
    title += ` - ${product.collections.name} Koleksiyonu`;
  }
  
  // Ürün tipi ekle
  title += ' | Telefon Kılıfı';
  
  // Marka ekle
  title += ' | Mr. Brown Case';
  
  return title;
};

/**
 * Ürün için uyumlu telefon modellerini formatlı string olarak döndürür
 * @param {Object} product - Ürün nesnesi
 * @returns {String} Uyumlu modeller listesi
 */
export const getCompatibleModelsText = (product) => {
  if (!product || !product.phone_models || product.phone_models.length === 0) {
    return '';
  }
  
  const modelNames = product.phone_models.map(model => model.name || `${model.brand} ${model.model_name}`);
  
  if (modelNames.length <= 3) {
    return modelNames.join(', ');
  }
  
  // Çok fazla model varsa ilk 3'ünü göster ve "ve daha fazlası" ekle
  return `${modelNames.slice(0, 3).join(', ')} ve ${modelNames.length - 3} model daha`;
};

/**
 * Ürün için SEO dostu alt metin oluşturur
 * @param {Object} product - Ürün nesnesi
 * @returns {String} SEO dostu alt metin
 */
export const generateImageAltText = (product) => {
  if (!product) return '';
  
  let altText = product.name;
  
  // Koleksiyon bilgisi ekle
  if (product.collections && product.collections.name) {
    altText += ` ${product.collections.name} koleksiyonu`;
  }
  
  // Telefon kılıfı bilgisi ekle
  altText += ' telefon kılıfı';
  
  // Marka bilgisi ekle
  altText += ' - Mr. Brown Case';
  
  return altText;
};

/**
 * Ürün için SEO dostu görsel başlığı oluşturur
 * @param {Object} product - Ürün nesnesi
 * @returns {String} SEO dostu görsel başlığı
 */
export const generateImageTitle = (product) => {
  if (!product) return '';
  
  return product.name;
};

/**
 * Ürün için SEO dostu görsel açıklaması oluşturur
 * @param {Object} product - Ürün nesnesi
 * @returns {String} SEO dostu görsel açıklaması
 */
export const generateImageCaption = (product) => {
  if (!product) return '';
  
  return `${product.name} - Mr. Brown Case`;
};

/**
 * Ürün için SEO meta açıklaması oluşturur
 * @param {Object} product - Ürün nesnesi
 * @returns {String} SEO meta açıklaması
 */
export const generateMetaDescription = (product) => {
  if (!product) return '';
  
  // Eğer ürünün kendi açıklaması varsa ve yeterince uzunsa onu kullan
  if (product.description && product.description.length > 50) {
    // Meta açıklamaları genellikle 150-160 karakter olmalı
    return product.description.substring(0, 157) + '...';
  }
  
  // Yoksa zenginleştirilmiş açıklama oluştur
  const enriched = enrichProductDescription(product);
  return enriched.substring(0, 157) + '...';
};

/**
 * Ürün için yapısal veri (schema.org) nesnesi oluşturur
 * @param {Object} product - Ürün nesnesi
 * @param {String} baseUrl - Site temel URL'i
 * @returns {Object} Yapısal veri nesnesi
 */
export const generateProductSchema = (product, baseUrl = 'https://www.mrbrowncase.com') => {
  if (!product) return null;
  
  // Sepet sayfasına URL oluştur
  const addToCartURL = `${baseUrl}/products/${product.id}`;
  
  // Stok durumunu daima "stokta var" kabul edelim
  // Gerçek stok durumu ürün detay sayfasında model ve renk seçimine göre dinamik olarak belirleniyor
  const isInStock = true;

  const schemaData = {
    "@context": "https://schema.org/",
    "@type": "Product",
    "name": product.name,
    "image": [product.images],
    "description": product.description || `${product.name} - Mr. Brown Case özel tasarım telefon kılıfı`,
    "sku": `MBC-${product.id}`,
    "mpn": `MBC-${product.id}`,
    "brand": {
      "@type": "Brand",
      "name": "Mr. Brown Case",
      "logo": `${baseUrl}/logo512.png`
    },
    "offers": {
      "@type": "Offer",
      "url": addToCartURL,
      "priceCurrency": "TRY",
      "price": product.price.toString(),
      "priceValidUntil": new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0],
      "availability": isInStock ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
      "seller": {
        "@type": "Organization",
        "name": "Mr. Brown Case",
        "logo": `${baseUrl}/logo512.png`
      }
    }
  };
  
  // Uyumlu modeller varsa ekle
  if (product.phone_models && product.phone_models.length > 0) {
    schemaData.compatibleWith = product.phone_models.map(model => ({
      "@type": "Product",
      "name": model.name || `${model.brand} ${model.model_name}`
    }));
  }
  
  // Değerlendirmeler varsa ekle
  if (product.reviews && product.reviews.length > 0) {
    schemaData.aggregateRating = {
      "@type": "AggregateRating",
      "ratingValue": product.average_rating || calculateAverageRating(product.reviews),
      "reviewCount": product.reviews.length
    };
    
    // İlk birkaç değerlendirmeyi ekle
    schemaData.review = product.reviews.slice(0, 3).map(review => ({
      "@type": "Review",
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": review.rating
      },
      "author": {
        "@type": "Person",
        "name": review.author_name || "Müşteri"
      },
      "reviewBody": review.content
    }));
  }
  
  return schemaData;
};

/**
 * Değerlendirmelerin ortalama puanını hesaplar
 * @param {Array} reviews - Değerlendirmeler dizisi
 * @returns {Number} Ortalama puan
 */
export const calculateAverageRating = (reviews) => {
  if (!reviews || reviews.length === 0) return 0;
  
  const sum = reviews.reduce((total, review) => total + (review.rating || 0), 0);
  return (sum / reviews.length).toFixed(1);
};

/**
 * Ürün için SEO dostu URL slug'ı oluşturur
 * @param {Object} product - Ürün nesnesi
 * @returns {String} SEO dostu URL slug'ı
 */
export const generateProductSlug = (product) => {
  if (!product || !product.name) return '';
  
  // Türkçe karakterleri dönüştür
  const turkishChars = { 'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u', 'Ç': 'C', 'Ğ': 'G', 'İ': 'I', 'Ö': 'O', 'Ş': 'S', 'Ü': 'U' };
  
  let slug = product.name.toLowerCase();
  
  // Türkçe karakterleri değiştir
  Object.keys(turkishChars).forEach(char => {
    slug = slug.replace(new RegExp(char, 'g'), turkishChars[char]);
  });
  
  // Özel karakterleri kaldır ve boşlukları tire ile değiştir
  slug = slug.replace(/[^a-z0-9\s-]/g, '')
             .replace(/\s+/g, '-')
             .replace(/-+/g, '-');
  
  // Koleksiyon adını ekle (varsa)
  if (product.collections && product.collections.name) {
    const collectionSlug = product.collections.name.toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-');
    
    slug = `${collectionSlug}-${slug}`;
  }
  
  return slug;
};

/**
 * Ürün için sitemap.xml değişim sıklığını belirler
 * @param {Object} product - Ürün nesnesi
 * @returns {String} Değişim sıklığı (daily, weekly, monthly)
 */
export const getSitemapChangeFrequency = (product) => {
  if (!product) return 'weekly';
  
  // Yeni ürünler için daha sık güncelleme
  const createdDate = new Date(product.created_at);
  const now = new Date();
  const daysSinceCreation = Math.floor((now - createdDate) / (1000 * 60 * 60 * 24));
  
  if (daysSinceCreation < 7) {
    return 'daily';
  } else if (daysSinceCreation < 30) {
    return 'weekly';
  } else {
    return 'monthly';
  }
};

/**
 * Ürün için sitemap.xml öncelik değerini belirler
 * @param {Object} product - Ürün nesnesi
 * @returns {Number} Öncelik değeri (0.0 - 1.0)
 */
export const getSitemapPriority = (product) => {
  if (!product) return '0.5';
  
  // Öne çıkan ürünlere daha yüksek öncelik ver
  if (product.is_featured) {
    return '0.9';
  }
  
  // Yeni ürünlere orta-yüksek öncelik ver
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  
  if (new Date(product.created_at) >= oneMonthAgo) {
    return '0.8';
  }
  
  // Stok durumuna göre öncelik belirle - artık stok durumunu product.stock'tan almıyoruz
  // Varsayılan olarak stok var kabul ediyoruz, gerçek stok kontrolü ürün sayfasında renk/model seçimine göre yapılıyor
  return '0.7';
  
  // Kategori bazlı öncelikler
  /* Kategori bazında özel öncelikler eklenebilir:
  if (product.collections) {
    if (product.collections.id === 1) return '0.75'; // Popüler koleksiyon
    if (product.collections.id === 2) return '0.65'; // Başka bir koleksiyon
  }
  */
};

/**
 * Ürün için Google Merchant Center feed'i için başlık oluşturur
 * @param {Object} product - Ürün nesnesi
 * @returns {String} Google Merchant Center başlığı
 */
export const generateMerchantTitle = (product) => {
  if (!product) return '';
  
  let title = product.name;
  
  // Marka ekle
  title = `Mr. Brown Case ${title}`;
  
  // Ürün tipi ekle
  title += ' Telefon Kılıfı';
  
  // Koleksiyon bilgisi ekle (varsa)
  if (product.collections && product.collections.name) {
    title += ` - ${product.collections.name} Koleksiyonu`;
  }
  
  return title.substring(0, 150); // Google Merchant Center başlık sınırı
};

/**
 * Ürün için sosyal medya paylaşım metni oluşturur
 * @param {Object} product - Ürün nesnesi
 * @returns {String} Sosyal medya paylaşım metni
 */
export const generateSocialShareText = (product) => {
  if (!product) return '';
  
  return `${product.name} telefon kılıfını keşfedin! Özel tasarım, yüksek kalite. #MrBrownCase #TelefonKılıfı #${product.name.replace(/\s+/g, '')}`;
};

/**
 * Ürün için SEO dostu görsel boyutları oluşturur
 * @param {Object} product - Ürün nesnesi
 * @param {String} size - Görsel boyutu (small, medium, large)
 * @returns {Object} Genişlik ve yükseklik değerleri
 */
export const getImageDimensions = (product, size = 'medium') => {
  const dimensions = {
    small: { width: 300, height: 300 },
    medium: { width: 600, height: 600 },
    large: { width: 1200, height: 1200 }
  };
  
  return dimensions[size] || dimensions.medium;
};

/**
 * Ürün için SEO dostu görsel URL'si oluşturur
 * @param {Object} product - Ürün nesnesi
 * @param {String} size - Görsel boyutu (small, medium, large)
 * @returns {String} SEO dostu görsel URL'si
 */
export const getOptimizedImageUrl = (product, size = 'medium') => {
  if (!product || !product.images) return '';
  
  // Eğer görsel URL'si zaten bir CDN veya optimize edilmiş bir URL ise doğrudan döndür
  if (product.images.includes('cdn') || product.images.includes('optimized')) {
    return product.images;
  }
  
  // Basit bir URL dönüşümü - gerçek uygulamada CDN veya görsel optimizasyon servisi kullanılmalı
  const baseUrl = product.images.split('?')[0];
  const dimensions = getImageDimensions(product, size);
  
  return `${baseUrl}?width=${dimensions.width}&height=${dimensions.height}&format=webp`;
};

/**
 * Ürünün stok durumunu kontrol eder
 * @param {Object} product - Ürün nesnesi
 * @returns {Boolean} Stokta varsa true, yoksa false
 */
export const checkProductAvailability = (product) => {
  // Stok kontrolü artık ürün detay sayfasında model ve renk seçimine göre dinamik olarak yapılıyor
  // Bu fonksiyon artık product.stock'a bakmıyor, varsayılan olarak true dönüyoruz
  return true;
}; 